import { Quantity } from '@jetshop/ui/Input/';
import React from 'react';
import styled from 'react-emotion';
import AddToCartButton from './AddToCartButton';
import QuantityContainer from '../QuantityContainer';

const QuantityButtonWrapper = styled('div')`
  display: flex;
  width: 100%;
  align-items: flex-end;
  > div {
    margin: 0;
    > label {
      display: none;
    }
    > input {
      width: 80px;
      background-color: ${({ theme }) => theme.colors.themeGrey};
      border: none;
      outline: none;
    }
  }
`;

export default class AddToCartWrapper extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (nextProps.product.id !== this.props.product.id) return true;
    if (nextProps.stockStatus.status !== this.props.stockStatus.status)
      return true;
    return false;
  }
  render() {
    const { product, stockStatus } = this.props;
    return (
      <QuantityButtonWrapper>
        <QuantityContainer>
          {({ quantity, setQuantity }) => (
            <>
              <Quantity
                defaultValue={quantity}
                onChange={e => setQuantity(e.currentTarget.value)}
              />
              <AddToCartButton
                quantity={quantity}
                product={product}
                inStock={stockStatus.status === 'inStock'}
              />
            </>
          )}
        </QuantityContainer>
      </QuantityButtonWrapper>
    );
  }
}
